export default class BlogCategoryModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.indexPos = 1;
    }
}